import { useParams } from "react-router-dom";
import NewWorkflowButton from "../components/NewWorkFlowButton";
import { ADLSPageProps } from "../utils/interface/ADLSPage";
import ADLSPageTable from "../components/ADLSPageTable";
import SpacsBox from "../components/HeroSection";
import { WorkflowCaregiver } from "../utils/HSMUtils";
import { UserOccupation } from "../utils/AppUtlis";
import { useEffect, useState } from "react";

const ADLSPage = ({ userContext, isPrivate, setCursor }: ADLSPageProps) => {
  const { avatar } = useParams();
  const [showButton, setshowButton] = useState(false);
  const [avatarsLoaded, setAvatarsLoaded] = useState(false);

  const defaultCaregiver =
    userContext && userContext.occupation === UserOccupation.ROBOTICIST
      ? WorkflowCaregiver.ROBOT
      : WorkflowCaregiver.HUMAN;

  useEffect(() => {
    async function getAvatars() {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URI}/avatar/${avatar}`
      );

      if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        window.alert(message);
        return;
      }

      const avatarObj = await response.json();

      // Check if the avatar is public or if the user is the creator 
      const isPublic = avatarObj.visibility === true;
      const isOwner = userContext && avatarObj.created_by === userContext.id;
      
      // Show button if user is logged in AND (avatar is public OR user is owner)
      setshowButton(userContext && (isPublic || isOwner));
    }

    if (!avatarsLoaded) {
      getAvatars();
    }
  }, [avatarsLoaded, userContext]);

  return (
    <div>
      <div className="container-md">
        <div className="row w-full  ">
          <SpacsBox
            heading="Browse and manage caregiving workflows"
            buttonTitle=" Workflows"
          />
        </div>
      </div>
      <div className="row w-8/12  justify-center   offset-2">
        <ADLSPageTable
          userContext={userContext}
          isPrivate={isPrivate}
          setCursor={setCursor}
        />
      </div>

      {showButton && (
        <div className="d-flex justify-content-center mt-4">
          <NewWorkflowButton
            text="New Workflow"
            btnClass="bg-black text-white p-3  rounded-full"
            caregiver={defaultCaregiver}
            defaultAvatarId={avatar}
          />
        </div>
      )}
    </div>
  );
};

export default ADLSPage;
